import { useQuery } from "@tanstack/react-query";
import { jeopardyApi } from "../api/jeopardy";

export const useFetchJeopardyDetails = (jeopardyID: string | undefined) => {

    const { data, isLoading, isSuccess, isError, isRefetching, error, refetch } = useQuery({
        queryKey: ["jeopardy-details", jeopardyID],
        queryFn: () => jeopardyApi.fetchJeopardyDetails(jeopardyID),
        enabled: !!jeopardyID,
    });

    return { data: isSuccess ? data.data : [], isLoading: isLoading || isRefetching, isError, error, refetch };

};